import { hashStringToSeed } from '../lib/videoRotation';

// DSP Cafe's Founding Sponsors — the same three, and the same links, as the
// landing page strip (`landing/index.html`). Descriptions are taken verbatim
// from each org's own logo alt text; nothing here is invented copy about a
// real organization.
export const SPONSORS = [
  {
    id: 'nadsp',
    name: 'NADSP',
    description: 'National Alliance for Direct Support Professionals',
    logo: '/assets/sponsors/nadsp.jpg',
    url: 'https://nadsp.org/',
  },
  {
    id: 'intellectability',
    name: 'IntellectAbility',
    description: null,
    logo: '/assets/sponsors/intellectability.png',
    url: 'https://www.replacingrisk.com/',
  },
  {
    id: 'naq',
    // description deliberately null: "Learn. Connect. Share." is baked into
    // NAQ's own logo artwork, so printing it beside the mark rendered the
    // tagline twice on one card. Null falls back to the bare domain, which is
    // what IntellectAbility already does. Nothing is invented either way —
    // this shows less, it does not reword a sponsor.
    name: 'NAQ',
    description: null,
    logo: '/assets/sponsors/naq.png',
    url: 'https://www.n-a-q.org/',
  },
];

// One sponsor per user per day. Three sponsors share ONE slot rather than
// taking three: the carousel keeps room for events and Staff Picks, and each
// sponsor gets an exact ~1/3 share of impressions — a straight answer to give
// a sponsor who asks what they got.
//
// Deliberately a rotating offset, not a random draw. Independent daily draws
// distribute perfectly in aggregate but are lumpy per person — measured over
// 30 days, one user saw 15/10/5 rather than 10/10/10. Offsetting a round-robin
// by a per-user hash gives every user exactly one of each per cycle AND keeps
// the aggregate split exact, because the offsets themselves spread evenly.
const dayIndex = (now) =>
  // Local Y/M/D through Date.UTC: a stable integer that flips at the user's
  // own midnight rather than UTC's.
  Math.floor(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 86_400_000);

export function pickDailySponsor(userId, sponsors = SPONSORS, now = new Date()) {
  if (!sponsors.length) return null;
  const offset = hashStringToSeed(String(userId ?? 'anon')) % sponsors.length;
  return sponsors[(dayIndex(now) + offset) % sponsors.length];
}
